<template>
  <v-content>
    <v-container class="fill-height py-0 my-0" fluid>
      <v-row align="center" justify="center" class="py-0 my-0">
        <v-col
          cols="12"
          sm="6"
          md="5"
          class="py-0 my-0 d-flex"
          style="background: #f5f5f5; height: 100vh; padding: 0"
        >
          <div
            class="mx-auto my-auto d-flex flex-column"
            style=" width: 100%; height: 100%; position: relative"
          >
            <img
              src="@/assets/logo-flextd.svg"
              alt="logo"
              width="250px"
              class="mx-auto"
              style="position: absolute; transform: translateX(-50%); left: 50%; top: 20%"
            />
            <img
              src="@/assets/fondo-flextd-login.webp"
              alt="centro"
              style="object-fit: cover; height: 100%;width: 100%"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="5" offset-md="2" class="d-flex">
          <v-card
            width="400"
            flat
            class="px-0 py-0 animate__animated animate__backInDown"
            style="
              box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
              border-radius: 20px !important;
              padding-top: 40px !important;
            "
          >
            <ValidationObserver ref="obs" v-slot="{ passes }">
              <v-col cols="12" md="12" class="mt-n5 pb-0">
                <label for="email">País</label>
                <ValidationProvider
                  name="Tienda"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    filled
                    :items="stores"
                    item-text="name"
                    item-value="id"
                    v-model="store"
                    name="tienda"
                    dense
                    type="text"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="12" class="pt-0">
                <label for="email">Usuario</label>
                <ValidationProvider
                  name="Nombre"
                  rules="email|required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="email"
                    class="mt-2"
                    color="accent"
                    dense
                    filled
                    placeholder="ejemplo@mail.com"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="12" class="mt-n5">
                <label for="email">Contraseña</label>
                <ValidationProvider
                  name="Contraseña"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    @keyup.enter="passes(login)"
                    type="password"
                    v-model="password"
                    class="mt-2"
                    color="accent"
                    dense
                    filled
                    placeholder="Enter your password"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" md="12">
                <v-btn
                  :loading="loading"
                  @click="passes(login)"
                  rounded
                  elevation="0"
                  large
                  block
                  dark
                  color="accent"
                >
                  Iniciar sesión
                </v-btn>
              </v-col>
              <v-col 
                cols="12" 
                md="12"
                style="padding-top: 0;"
              >
                <v-btn
                  :disabled="loading"
                  @click="goToSignUp"
                  rounded
                  elevation="0"
                  large
                  block
                  dark
                  color="primary"
                >
                  Registrate
                </v-btn>
              </v-col>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },

  data() {
    return {
      email: "",
      password: "",
      stores: [
        { id: 6, name: "Chile" },
        { id: 5, name: "Argentina" },
        { id: 10, name: "Mexico" },
      ],
      store: 6,
      showPassword: false,
      loading: false,
    };
  },

  created() {
    // this.getStores();
  },

  methods: {
    async getStores() {
      try {
        const request = {
          paginate: false,
        };
        const response = await this.$store.dispatch(
          "product/GET_STORE",
          request
        );
        const storeB2b = response.filter((sto) => sto.b2b_active == true);
        console.log(storeB2b);
        this.stores = storeB2b;
      } catch (error) {
        console.log(error);
      }
    },

    goToSignUp(){
      this.$router.push({ name: "signup" });
    },

    async login() {
      this.loading = true;
      if (![5, 6].includes(this.store)) {
        this.$snotify.error(
          "El pais seleccionado no está disponible",
          "¡Vaya!"
        );
        this.loading = false;
        return;
      }
      try {
        const request = {
          email: this.email,
          password: this.password,
          store: this.store,
        };
        await this.$store.dispatch("auth/LOGIN", request);
        this.$router.push({ name: "order_tracking" });
      } catch (error) {
        console.log(error);
        this.loading = false;
        if (error.response) {
          this.$snotify.error("Credenciales inválidas", "Error");
        } else {
          this.$snotify.error("El servidor no responde. Error 500", "¡Vaya!");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.bg-login {
  background-image: url("../../assets/login_morado_2.svg");
  background-position: left center;
  background-attachment: fixed;
  transform: rotate(180deg);
  height: 100vh;
}
.position-login {
  transform: rotate(180deg);
}

.round-xs {
  border-radius: 4px !important;
}
.round-small {
  border-radius: 10px !important;
}
.round {
  border-radius: 20px !important;
}

.shadow-large {
  box-shadow: 0 1px 15px rgba(27, 31, 35, 0.15) !important;
}
.shadow-medium {
  box-shadow: 0 2px 43px -4px rgba(0, 0, 0, 0.19) !important;
}
.shadow-small {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
  border-radius: 20px !important;
}
.text-title {
  color: #897de1;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: rgba(109, 96, 218, 0.4) !important;
}
</style>
